import { Signal } from '../core/Signal';

export interface ScoreUpdatedPayload {
  oldScore: number;
  newScore: number;
  delta: number;
  timestamp: number;
}

export interface HighscoreAchievedPayload {
  oldHighscore: number;
  newHighscore: number;
  timestamp: number;
}

export interface LevelCompletePayload {
  level: number;
  score: number;
  timeElapsed: number;
  timestamp: number;
}

export const createScoreSignals = (debugMode: boolean = false) => ({
  scoreUpdated: new Signal<ScoreUpdatedPayload>(
    'score.scoreUpdated',
    debugMode
  ),
  highscoreAchieved: new Signal<HighscoreAchievedPayload>(
    'score.highscoreAchieved',
    debugMode
  ),
  levelComplete: new Signal<LevelCompletePayload>(
    'score.levelComplete',
    debugMode
  ),
});

export type ScoreSignals = ReturnType<typeof createScoreSignals>;
